"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const HelperUtils_1 = require("utils/HelperUtils");
const Tooltip_1 = __importDefault(require("components/design-system/Tooltip"));
require("./TextArea.scss");
const TextArea = ({ className = '', textPlaceholder, id, width, height = 32, value, onHandleChange, dataCy, disabled = false, readonly, defaultValue, maxHeight = 88, maxLength, isTransparent = true, onBlur = () => null, showBorderOnHover, onMouseEnter = () => null, onMouseLeave = () => null, onKeyDown, autoFocus, typographyClass = 'typography-paragraph', paddingClass = 'py-[4px] px-[9px]', isError, errorMessage }) => {
    const textareaRef = (0, react_1.useRef)(null);
    const resize = (0, react_1.useCallback)((el) => {
        if (!el)
            return;
        el.setAttribute('rows', 1);
        const row = Math.ceil(el.scrollHeight / height);
        el.setAttribute('rows', row);
    }, [height]);
    const onChange = (e) => {
        const el = e.target;
        resize(el);
        if (onHandleChange) {
            onHandleChange(e);
        }
    };
    const props = {
        readOnly: readonly,
        placeholder: textPlaceholder,
        onChange: onChange,
        cols: width,
        height: height,
        disabled: disabled,
        onBlur: onBlur,
        id: id,
        maxLength,
        onMouseEnter,
        onMouseLeave,
        onKeyDown,
        autoFocus,
        ...((0, isEmpty_1.default)(defaultValue) ? { value } : { defaultValue })
    };
    (0, react_1.useEffect)(() => {
        resize(textareaRef.current);
    }, [value, defaultValue, resize]);
    const textAreaCN = (0, classnames_template_literals_1.default)(`
    shared-textarea
    leading-[22px]
    w-full text-n-800 rounded-[4px]
    ${isTransparent ? 'state-secondary-purple' : ''}
    ${readonly || disabled ? 'bg-n-100' : 'bg-n-000'}
    ${className && className}
    ${showBorderOnHover && 'show-border-on-hover'}
    ${typographyClass}
    ${paddingClass}
    ${isError && 'border border-r-600 border-solid'}
  `);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isError && (react_1.default.createElement("div", { className: "relative" },
            react_1.default.createElement(Tooltip_1.default, { customClass: "absolute top-[-8px] typography-paragraph right-0 transform -translate-y-full text-right !max-w-[100%]", text: (0, HelperUtils_1.getObjectiveLocale)(errorMessage) }))),
        react_1.default.createElement("textarea", { className: textAreaCN, style: {
                minHeight: height + 'px',
                maxHeight: maxHeight + 'px',
                overflow: 'auto'
            }, ref: textareaRef, "data-cy": dataCy, rows: 1, ...props })));
};
TextArea.defaultProps = {
    textPlaceholder: 'Placeholder',
    cols: 40
};
exports.default = TextArea;
